// FAMILY-EXT: переключатель тёмной темы. Применяется добавлением CSS-класса
// `family-dark-theme` на корневой элемент #app. Состояние хранится в
// localStorage, чтобы переживало релоады.

const STORAGE_KEY = 'family-dark-theme';
const CLASS_NAME = 'family-dark-theme';

function getRoot() {
  if (typeof document === 'undefined') return null;
  return document.getElementById('app');
}

export function isFamilyDarkTheme() {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === '1';
}

export function applyFamilyTheme(enabled) {
  const root = getRoot();
  if (!root) return;
  root.classList.toggle(CLASS_NAME, enabled);
}

export function setFamilyDarkTheme(enabled) {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, enabled ? '1' : '0');
  }
  applyFamilyTheme(enabled);
}

export function toggleFamilyDarkTheme() {
  const next = !isFamilyDarkTheme();
  setFamilyDarkTheme(next);
  return next;
}

// Применяется как только модуль импортирован (раньше первого рендера).
// Класс на #app проставляется до того, как React что-либо отрисует —
// чтобы не было flash светлой темы.
applyFamilyTheme(isFamilyDarkTheme());
